module.exports = __webpack_public_path__ + "946bf738c638f3b2297af6e80a95b22b.jpg";